import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ListaService } from '../../_services/lista.service';
import { PlagaService } from '../../_services/plaga.service';
import { Plaga } from '../../_models/plaga';

@Component( {
  selector: 'app-plaga-listado',
  templateUrl: 'plaga-listado.component.html'
} )

export class PlagaListadoComponent implements OnInit {

  lisPlaga: Plaga[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private navServicio: NavService,
               private router: Router,
               private lisServicio: ListaService,
               private autServicio: AutenticacionService,
               private serPlaga: PlagaService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/plaga' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PLAGA.LBL_NOMBREPLAGA' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.navServicio.getSearch( 'plaga-listado.component' );

    this.serPlaga.listado().subscribe( plaga => {
      this.lisPlaga = plaga;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );

  }

  crear() {
    this.router.navigate( [ 'apl/plaga/agregar' ] );
  }

  visualizar( registro: Plaga ) {
    this.router.navigate( [ 'apl/plaga/detalle/' + registro.idPlaga ] );
  }

  editar( registro: Plaga ) {
    this.router.navigate( [ 'apl/plaga/actualizar/' + registro.idPlaga ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'plaga-listado.component', this.busqueda );
  }
}
